import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import TabsContainerData from '../../../Models/Content/TabsContainerBlockData';
import TabsContainer from './TabsContainer';
export default class TabsContainerBlock extends EpiComponent<TabsContainerData> {
 
  
    constructor(props) {
      super(props);
    }
  
    public render(): ReactNode | ReactNodeArray | null {
      return <TabsContainer context={this.getContext()} data={this.props.data} />                
    }
 
}
